/**
 * @fileoverview Capturing bug report details and submitting data to an API endpoint.
 *
 * @author Madhu Pavan
 * @date 10th May, 2024
 *
 * @reviewer Jai Prakash Ellapu
 * @date 13th May, 2024
 *
 * Bug-report details are taken as input from the user and delivered to the server.
 *
 * @copyright Copyright (C) 2024 QualiZeal India LLP
 *
 * @license Closed - QualiZeal India LLP - Intellectual Property
 *
 * @todo Input validations
 */

import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sessionValidation } from "./webServices";
import { persistor } from "../store";
// import { clearReqnrollData } from "../store/slices/test-automation/web/flow-stages/playwirghtCSharpReqnrollSlice";

async function validateSession(setAuth, setSessionExpiration, dispatch) {
  try {
    const validationResult = await sessionValidation();
    const isValid = validationResult.isValidSession;

    setAuth(isValid);

    // If session is invalid, clear all persisted Redux data
    if (!isValid) {
      console.log("Invalid session detected - clearing persisted data");
      // dispatch(clearReqnrollData());
      await persistor.purge();
    }

    if (validationResult.sessionExpiration) {
      setSessionExpiration(validationResult.sessionExpiration);
    }
  } catch (error) {
    console.log(error, "session ping error");
    // On error, also clear persisted data
    setAuth(false);
    // dispatch(clearReqnrollData());
    await persistor.purge();
  }
}

async function validateAdminSession(setAdminAuth, dispatch) {
  try {
    const validationResult = await sessionValidation();
    const isAdmin =
      validationResult.role === "admin" ||
      validationResult.role === "super_admin";

    setAdminAuth(isAdmin);

    // Clear if not admin
    if (!isAdmin) {
      // dispatch(clearReqnrollData());
      await persistor.purge();
    }
  } catch (error) {
    setAdminAuth(false);
    // dispatch(clearReqnrollData());
    await persistor.purge();
  }
}

export async function validateRagAdminSession(setRagAdminAuth, dispatch) {
  try {
    const validationResult = await sessionValidation();
    const isRagAdmin =
      validationResult.role === "rag_admin" ||
      validationResult.role === "super_admin";

    setRagAdminAuth(isRagAdmin);

    // Clear if not rag admin
    if (!isRagAdmin) {
      // dispatch(clearReqnrollData());
      await persistor.purge();
    }
  } catch (error) {
    setRagAdminAuth(false);
    // dispatch(clearReqnrollData());
    await persistor.purge();
  }
}

const GuardedUserRoute = () => {
  const [auth, setAuth] = useState(null);
  const [sessionExpiration, setSessionExpiration] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("mmmm")
    validateSession(setAuth, setSessionExpiration, dispatch);
  }, [dispatch]);

  if (auth === null) {
    return <div>Loading...</div>;
  }

  return auth ? (
    <Outlet context={{ sessionExpiration }} />
  ) : (
    <Navigate to="/" replace={true} />
  );
};

const GuardedAdminRoute = () => {
  const [adminAuth, setAdminAuth] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    validateAdminSession(setAdminAuth, dispatch);
  }, [dispatch]);

  if (adminAuth !== null) {
    return adminAuth ? (
      <Outlet />
    ) : (
      <Navigate to="/dashboard/admin-navigation/settings" replace={true} />
    );
  } else {
    return <div>Loading...</div>;
  }
};

const GuardedRagAdminRoute = () => {
  const [auth, setAuth] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    validateRagAdminSession(setAuth, dispatch);
  }, [dispatch]);

  if (auth === null) return <div>Loading...</div>;

  return auth ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard/admin-navigation/settings" replace />
  );
};

const GuardedUserLogin = () => {
  const [auth, setAuth] = useState(null);
  const [sessionExpiration, setSessionExpiration] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("hdks")
    validateSession(setAuth, setSessionExpiration, dispatch);
  }, [dispatch]);

  if (auth === null) {
    return <div>Loading...</div>;
  }

  return !auth ? (
    <Outlet sessionExpiration={sessionExpiration} />
  ) : (
    <Navigate
      to="/landingpage"
      replace={true}
      sessionExpiration={sessionExpiration}
    />
  );
};

export {
  GuardedUserRoute,
  GuardedUserLogin,
  GuardedAdminRoute,
  GuardedRagAdminRoute,
};
